import { VideoTemplatesPageContext } from '@anm/contexts/VideoTemplatesPageContext';
import { useContext, useEffect, RefObject } from 'react';

export const usePauseVideoOnUnmount = (
  playerWrapperRef: RefObject<HTMLDivElement>
) => {
  const { pageName } = useContext(VideoTemplatesPageContext);

  useEffect(
    () => () => {
      if (!playerWrapperRef.current) return;

      const video = playerWrapperRef.current.querySelector('video');
      !video?.paused && video?.pause();
    },
    [pageName, playerWrapperRef?.current]
  );
};
